import React, { Component } from 'react';
import { strings } from '../utils/translations.js'
import PropTypes from 'prop-types'
import API from '../utils/API'
import moment from 'moment'
import styles from './HouseSubscriptionsView.module.scss'
import classnames from 'classnames'
import { Checkbox } from 'antd'
import { Utils } from '../utils/utils'

export default class HouseSubscriptionsView extends Component
{
	constructor(props)
	{
		super(props)

		this.state =
		{
            isLoading: false,
			subscriptions: [],
            selectedSubscription: null
		}
	}
    componentDidMount()
    {
        this.getSubscriptions()
    }

	render()
	{
		return (
            <div className={styles.houseSubscriptionsView}>
                { this.state.subscriptions.map(sub => this.renderSubscriptionItem(sub)) }
            </div>
		)
	}
    renderSubscriptionItem(item)
    {        
        let subscriptionType = item.type
        let subscriptionStatus = item.status
        let subscriptionIcon = require('../../img/icons/remote_big_gray.svg').default
        let subscriptionTitle = strings('vrPermissionTitleFree')
        let subscriptionSubtitle = `${item.minAvailableVRs} ${item.minAvailableVRs === 1 ?
										strings('selectSubscriptionAvailableRemotesSing') :
										strings('selectSubscriptionAvailableRemotes')}`
        let subscriptionSubtitle2 = strings('vrPermissionDoesntExpire')
        let isExpired = item.virtualRemotes[0]?.virtualRemote?.expired
        
        if (subscriptionType === '1 year')
        {
            subscriptionIcon  	 = require('../../img/icons/remote_big_purple.svg').default
            subscriptionTitle 	 = strings('vrPermissionTitle1Year')
            subscriptionSubtitle2 = isExpired ?
                                    `${strings('expiredOn')} ${moment(item.virtualRemotes[0]?.expireDate).format('LL')}`
                                    : `${strings('expires')}: ${moment(item.virtualRemotes[0]?.expireDate).format('LL')}`
        }
        else if (subscriptionType === '5 years')
        {
            subscriptionIcon  	 = require('../../img/icons/remote_big_gold.svg').default
            subscriptionTitle 	 = strings('vrPermissionTitle5Year')
            subscriptionSubtitle2 = isExpired ?
                                    `${strings('expiredOn')} ${moment(item.virtualRemotes[0]?.expireDate).format('LL')}`
                                    : `${strings('expires')}: ${moment(item.virtualRemotes[0]?.expireDate).format('LL')}`
        }
        
        let isSelected = this.state.selectedSubscription?.id === item.id
		let subHasEnoughVRs = (item.minAvailableVRs >= this.props.minRemotesNeeded)
        
        return (
            <Checkbox
                key={item.id}
                checked={isSelected}
                onChange={(e) => this.onCheckChanged(e, item)}
				disabled={!subHasEnoughVRs}
            >
                <div className={classnames(styles.subscriptionContainer,
											!subHasEnoughVRs ? styles.disabled : null)}
				>
                    <div className={styles.subscription}>
						<div className={styles.subscriptionIconContainer}>
                        	<img className={styles.subscriptionIcon} src={subscriptionIcon} />
							<div className={classnames(styles.remotesCount,
														(subscriptionType === '1 year') ? styles.purple : null,
														(subscriptionType === '5 years') ? styles.golden : null)}
							>
								x{ item.virtualRemotes.length }
							</div>
						</div>
                        <div className={styles.subscriptionTexts}>
                            <div className={styles.subscriptionTitle}>
								{ subscriptionTitle }
							</div>
                            <div className={styles.subscriptionSubtitle}>
                                { subscriptionSubtitle }
                                {
                                    (subscriptionStatus === 'trial') &&
                                    <span className={styles.orange}> ({strings('trialMode').toLowerCase()})</span>
                                }
								{
                                    (subscriptionStatus === 'past_due') &&
                                    <span className={styles.orange}> ({strings('pastDue').toLowerCase()})</span>
                                }
                            </div>
                            {
                                subscriptionSubtitle2 &&
                                <div className={classnames(styles.subscriptionSubtitle, isExpired ? styles.orange : null)}>
                                    { subscriptionSubtitle2 }
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={styles.separator} />
            </Checkbox>
        )
    }

	async getSubscriptions()
    {
        this.setState({ isLoading: true })
        
        try
        {
            let res = await API.getInstance().getVirtualRemotesByDoor(this.props.selectedDoors[0]?.id)
			let myRemotes = res.data.virtualRemotes.filter(vr => vr.ownerUserId == API.getInstance().getUserId())
            let subscriptions = Utils.getSubscriptionsFromVirtualRemotes(myRemotes)
            
            // Filter subs removing the expired trials
            let filteredSubs = subscriptions.filter(s => s.status != 'trial' || !s.virtualRemotes[0]?.virtualRemote?.expired)
            
            this.setState({ subscriptions }, () =>
            {
				this.setMaxAvailableRemotesForSubs()
                    
                if (this.props.onGetSubscriptions != null)
                    this.props.onGetSubscriptions(subscriptions)
            })
        }
        catch(error)
        {
            console.log(error)
        }
        finally
        {
            this.setState({ isLoading: false })
        }
    }
	setMaxAvailableRemotesForSubs()
	{
		this.state.subscriptions.forEach(s =>
		{
			let numAvailableVRsForSub = []
			
			// Checks the available VRs for each selected door and returns the minimum
			this.props.selectedDoors.forEach(d =>
			{
				let availableRemotesForSub = d.virtualRemotes.filter(vr => ((s.id === 'permanent') ? vr?.subscription === null : vr?.subscription?.id === s.id) &&
																			vr?.assignedUserId === 0 &&
															  	  			vr?.reserved === 0)
				numAvailableVRsForSub.push(availableRemotesForSub.length)												
			})
			
			s.minAvailableVRs = Math.min(...numAvailableVRsForSub)
		})
	}
    onCheckChanged(e, sub)
    {
        this.setState({ selectedSubscription: e.target.checked ? sub : null }, () =>
        {
            if (this.props.onSubscriptionSelected != null)
                this.props.onSubscriptionSelected(this.state.selectedSubscription)
        })
    }
}


HouseSubscriptionsView.propTypes =
{
    selectedDoors: PropTypes.any.isRequired,
    onGetSubscriptions: PropTypes.func,
    onSubscriptionSelected: PropTypes.func,
	minRemotesNeeded: PropTypes.any
}